export enum StatusType {
    INIT = "INIT",
    LOADING = "LOADING",
    READY = "READY",
    FAILED = "FAILED"
}